import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", variant = "dark", linkTo = "/", className = "" }) => {
  const sizes = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-3xl",
  };
  const cxColor = variant === "light" ? "text-white" : "text-[#071225]";
  const accentColor = "text-[#2D6BFF]";
  const Wrapper = linkTo ? Link : "div";
  return (
    <Wrapper to={linkTo} className={`inline-flex items-center font-display font-bold tracking-tight ${sizes[size]} ${cxColor} ${className}`}>
      <span>C</span>
      <span className={accentColor}>X</span>
      <span>O</span>
      <span className={accentColor}>O</span>
      <span>RA</span>
    </Wrapper>
  );
};

export default Logo;
